import { OwcIconButton, OwcListItem, OwcMenu } from "@one/react";
import { useContext, useState } from "react";
import ReactDOM from "react-dom";
import { v4 } from "uuid";
import { MyLabMenuArray } from "../../constants";
import { EquipmentsContext } from "../equipment-context/context";
import { getFieldValue } from "../booking-instruments/helpers";

const EquipmentAction = ({
  params,
  removeMyLabEquipment,
  updateMyLabEquipment,
}) => {
  const [anchorEl, setAnchorEl] = useState(false);
  const { myLabEquipment } = useContext(EquipmentsContext);

  let paramsValue = null;
  paramsValue = getFieldValue(params.data, "id")?.toString();

  const handleSettingClose = () => {
    setAnchorEl(false);
  };

  const handleSettingClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const menuId = v4();

  const handleClick = (option) => {
    setAnchorEl(false);
    switch (option) {
      case "remove":
        removeMyLabEquipment(getFieldValue(params.data, "id"));
        break;
      case "add":
        updateMyLabEquipment(getFieldValue(params.data, "id"));
        break;
      default:
    }
  };

  return (
    <>
      {params?.data?.id && getFieldValue(params.data, "id") !== "dummyRow" && (
        <>
          <OwcIconButton
            icon="more_vertical"
            type="legacy"
            flat
            onClick={(event) => {
              handleSettingClick(event, params);
            }}
            id={menuId}
          />
          {ReactDOM.createPortal(
            <OwcMenu
              data-testid="simple-menu"
              anchor={menuId}
              visible={anchorEl}
              onClickOutside={handleSettingClose}
              disablePortal={true}
            >
              {MyLabMenuArray.map((item) => {

                let canShow = true;
                if (myLabEquipment.includes(paramsValue)) {
                  if (item.key === "add") {
                    canShow = false;
                  } else if (item.key === "remove") {
                    canShow = true;
                  }
                } else {
                  if (item.key === "add") {
                    canShow = true;
                  } else if (item.key === "remove") {
                    canShow = false;
                  }
                }


                return (
                  canShow && (
                    <OwcListItem
                      key={item.key}
                      onClick={() => {
                        handleClick(item.key);
                      }}
                    >
                      {item.value}
                    </OwcListItem>
                  )
                );
              })}
            </OwcMenu>,
            document.body
          )}
        </>
      )}
    </>
  );
};

export default EquipmentAction;
